import QuickReport from "./quickReport";
import QuickLink from "./quickLink";
import QuickSetting from "./quickSetting";
import QuickAction from "./quickAction";

export { QuickReport, QuickLink, QuickSetting, QuickAction };
